<div class="flex flex-col">
  <h1 matDialogTitle class="mb-8">{{ data.title }}</h1>
  <div mat-dialog-content class="mb-16">{{ data.message }}</div>

  <div
    class="flex flex-row justify-center items-center gap-12 dialog-button-row"
  >
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="dialogRef.close(false)"
    >
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="dialogRef.close(true)">
      OK
    </button>
  </div>
</div>
